export const SEGMENT_FEATURE = "segments";
export const RENDER_GPS_COORDINATES_FEATURE = "gps_coordinate";
export const ORDER_ATTACHMENT = "order_attachment";
export const MULTIPLE_ORDERS_MAP_VIEW = "multiple_orders_map_view";

export const FEATURE_FLAGS = {
  dev: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: true,
    [ORDER_ATTACHMENT]: true,
    [MULTIPLE_ORDERS_MAP_VIEW]: true,
  },
  development: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: true,
    [ORDER_ATTACHMENT]: true,
    [MULTIPLE_ORDERS_MAP_VIEW]: true,
  },
  test: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: true,
    [ORDER_ATTACHMENT]: true,
    [MULTIPLE_ORDERS_MAP_VIEW]: true,
  },
  perf: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: true,
    [ORDER_ATTACHMENT]: true,
    [MULTIPLE_ORDERS_MAP_VIEW]: true,
  },
  staging: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: false,
    [ORDER_ATTACHMENT]: false,
    [MULTIPLE_ORDERS_MAP_VIEW]: false,
  },
  uat: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: false,
    [ORDER_ATTACHMENT]: false,
    [MULTIPLE_ORDERS_MAP_VIEW]: false,
  },
  demo: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: false,
    [ORDER_ATTACHMENT]: false,
    [MULTIPLE_ORDERS_MAP_VIEW]: false,
  },
  poc: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: false,
    [ORDER_ATTACHMENT]: false,
    [MULTIPLE_ORDERS_MAP_VIEW]: false,
  },
  production: {
    [SEGMENT_FEATURE]: true,
    [RENDER_GPS_COORDINATES_FEATURE]: false,
    [ORDER_ATTACHMENT]: false,
    [MULTIPLE_ORDERS_MAP_VIEW]: false,
  },
};

export const hasFeatureFlag = (flag: string): boolean => {
  const env = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT || "development";
  return FEATURE_FLAGS[env]?.[flag] || false;
};

export const permissionFlags = (list: string[], key: string): boolean => {
  return list?.some((item) => item === key);
};
